export default "__VITE_ASSET__$vw3fPK2__"